import { order } from './order.i18n';

export const en = {
  order,
};
